import { z } from "zod";

import { DbEnum } from "../../../../../generated/prisma-enums";

/**
 * Create Phone Number Request Body Schema
 *
 * Used when a user requests a phone number in a restricted country.
 */
export const CreatePhoneNumberRequestBodySchema = z.object({
  countryCode: z
    .string()
    .length(2, "Country code must be 2 characters")
    .toUpperCase()
    .regex(/^[A-Z]{2}$/, "Country code must be ISO 3166-1 alpha-2 format"),

  useCase: z.enum(DbEnum.PHONE_NUMBER_USE_CASE_VALUES, {
    error: "Invalid use case"
  }),

  justification: z.string().max(1000, "Note must be less than 1000 characters").trim().optional(),

  expectedVolume: z.number().int().positive("Expected volume must be a positive number").optional(),

  // Twilio connection (subaccount) to assign phone to
  connectionId: z.string().uuid()
});

export type CreatePhoneNumberRequestBody = z.infer<typeof CreatePhoneNumberRequestBodySchema>;
